import * as React from "react";
import { styled } from "@mui/material";
import { PatientSummaryData } from "fe-common/graphql";
import clsx from "clsx";
import { useSummaryTranslations } from "fe-web-components/patientCard/translate/useSummaryTranslations";
import { CommonColors } from "fe-web-components/colors/commonColors";
//region [[ Styles ]]

const PatientInfoView = styled("div")({
  display: "flex",
  flexFlow: "column",
});

const ChiefComplaintTitle = styled("div")({
  color: CommonColors.Default,
  fontWeight: 500,
  fontSize: "14px",
  lineHeight: "15px",
  marginBottom: "12px",
});

const ChiefComplaintText = styled(ChiefComplaintTitle)({
  fontWeight: 700,
  fontSize: "20px",
  lineHeight: "22px",
  marginBottom: 0,
});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface PatientInfoProps {
  className?: string;
  summary: PatientSummaryData;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const PatientInfo = ({ summary, ...props }: PatientInfoProps) => {
  const { translate } = useSummaryTranslations(summary);
  return (
    <PatientInfoView className={clsx("patient-info", props.className)}>
      <ChiefComplaintTitle>{translate("CHIEF_COMPLAINT")}</ChiefComplaintTitle>
      <ChiefComplaintText>{summary.main}</ChiefComplaintText>
    </PatientInfoView>
  );
};
